module.exports = "<div class=\"md-padding breadcrumb\"><ul class=\"list-unstyled d-flex m5 ng-cloak\"><li class=\"breadcrumb-item home\"><a ui-sref=home.home><md-icon class=material-icons>home</md-icon></a><li class=\"breadcrumb-item active\">Como comprar</ul></div><md-content class=\"ml15 mr15\" layout=column><div ng-bind-html=\"shCtrl.globalParams.cmsInfo.COMO_COMPRAR | toTrusted\"></div></md-content>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/static-views/views/how-buy-adaptative.html
 ** module id = 788
 ** module chunks = 7
 **/